<template>
  <div
    v-if="widget"
    class="hbt"
  >
    <div class="hbt-sec-head">
      <span class="hbt-h2">{{ widget.param.title || 'Неделя' }}</span>
      <span class="hbt-kicker">{{ widget.param.subtitle || `last ${days} days` }}</span>
    </div>
    <div
      v-for="row in rows"
      :key="row.id"
      class="hbt-week-row"
      :style="gridStyle"
    >
      <div style="font-size: 13px; font-weight: 600;">
        {{ row.name }}
      </div>
      <div
        v-for="cell in row.cells"
        :key="cell.key"
        class="hbt-cell"
        :title="cell.title"
        :style="cell.style"
      >{{ cell.label }}</div>
    </div>
    <div
      class="hbt-week-days"
      :style="gridStyle"
    >
      <div />
      <div
        v-for="d in dayHeads"
        :key="d.key"
        style="text-align: center; font-size: 10px; letter-spacing: 0.06em; text-transform: uppercase; color: rgba(32,30,29,0.55);"
      >{{ d.label }}<br>{{ d.num }}</div>
    </div>
  </div>
</template>

<script>
import {
  HBT_REFRESH, hbtLoadHabits, hbtLoadLogs, hbtDayKey, hbtCellStyle, hbtWeekDayShort, hbtHabitDayPct,
} from '@/cubus/components/dashboard/habits/habitsCore'

export default {
  name: 'CbsWidgetHabitWeek',
  props: {
    widget: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      habits: [],
      logs: [],
    }
  },
  computed: {
    days() {
      return Number(this.widget.param.days) || 7
    },
    gridStyle() {
      return {
        display: 'grid',
        gridTemplateColumns: `1fr repeat(${this.days}, 34px)`,
        gap: '6px',
        alignItems: 'center',
      }
    },
    dayKeys() {
      const keys = []
      const d = new Date()
      d.setDate(d.getDate() - (this.days - 1))
      for (let i = 0; i < this.days; i += 1) {
        keys.push({ key: hbtDayKey(d), date: new Date(d) })
        d.setDate(d.getDate() + 1)
      }
      return keys
    },
    dayHeads() {
      return this.dayKeys.map(k => ({
        key: k.key,
        label: hbtWeekDayShort(k.date),
        num: k.date.getDate(),
      }))
    },
    rows() {
      return this.habits
        .filter(h => h.type !== 'measure')
        .map(h => ({
          id: h.id,
          name: h.name,
          cells: this.dayKeys.map(k => {
            const total = this.logs
              .filter(l => l.habitId === h.id && l.day === k.key)
              .reduce((a, l) => a + l.reps, 0)
            const pct = hbtHabitDayPct(h, total)
            const st = hbtCellStyle(pct)
            let label
            if (h.type === 'check') label = total > 0 ? '✓' : '—'
            else label = pct > 0 ? Math.min(999, pct) : '—'
            return {
              key: k.key,
              label,
              title: `${h.name}: ${pct}%`,
              style: { background: st.background, color: st.color, borderColor: st.borderColor },
            }
          }),
        }))
    },
  },
  created() {
    this.load()
    this.$root.$on(HBT_REFRESH, this.reload)
  },
  beforeDestroy() {
    this.$root.$off(HBT_REFRESH, this.reload)
  },
  methods: {
    async load() {
      this.habits = await hbtLoadHabits(this, this.widget.param)
      await this.reload()
    },
    async reload() {
      this.logs = await hbtLoadLogs(this, this.widget.param, this.days)
    },
  },
}
</script>

<style src="./habits/habits.css"></style>
<style scoped>
.hbt-week-row {
  padding: 8px 0;
  border-bottom: 1px solid rgba(32, 30, 29, 0.4);
}
.hbt-week-days {
  margin-top: 6px;
}
</style>
